import { useStore } from 'engine/store';
import { BunnyMediaRenderer } from './BunnyMediaRenderer';

export const SkinLogo = () => {
	const skin = useStore((s) => s.skin);

	return (
		<div className="grid size-40 place-items-center rounded-full">
			{skin?.skinLogo && <BunnyMediaRenderer media={skin.skinLogo} />}
			{!skin?.skinLogo && <img className="text-gray-600" src="/icon.png" />}
		</div>
	);
};
